import Colors from './colors';

export const datatableThStyles = {
  backgroundColor: Colors.background.GRAY_BLUE,
  color: Colors.tableHeadingText,
  paddingTop: '1em',
  paddingBottom: '1em',
  fontWeight: 'normal',
  textAlign: 'left',
  paddingLeft:'0.5em'
};

// convenience for using one of our style objects in a react-table
// callback prop
export const styleify = (obj) => {
  return () => { return { style: obj }};
}



// WEBPACK FOOTER //
// ./src/styles/table-styles.js